import React, { useRef } from "react";
import PropTypes from "prop-types";
import { InputNumber, SelectPicker } from "rsuite";
import deleteIcon from "../../../assets/img/delete.svg";

const ltTypes = [
  { label: "Minimum no. of days before check-in", value: "1" },
  { label: "Maximum no. of days before check-in", value: "2" },
  { label: "Range", value: "3" },
];

/**
 * LeadTimeSection - Lead time section with type selector and input fields
 */
function LeadTimeSection({
  ltType = "1",
  minBookingLeadTime = null,
  maxBookingLeadTime = null,
  onLtTypeChange,
  onMinMaxChange,
  onRangeChange,
  onRemove,
  hasError = false,
}) {
  const ltTypePopUpRef = useRef(null);

  const renderInput = () => {
    if (ltType === "1") {
      return (
        <InputNumber
          value={minBookingLeadTime}
          min={1}
          max={999}
          onChange={(value) => onMinMaxChange(value, ltType)}
          placeholder={""}
          block
        />
      );
    } else if (ltType === "2") {
      return (
        <InputNumber
          value={maxBookingLeadTime}
          min={1}
          max={999}
          onChange={(value) => onMinMaxChange(value, ltType)}
          placeholder={""}
          block
        />
      );
    } else if (ltType === "3") {
      return (
        <div className="los-lt-range-inputs">
          <div className={hasError ? "input-error" : ""}>
            <InputNumber
              value={minBookingLeadTime}
              min={1}
              max={999}
              onChange={(value) => onRangeChange(value, "min")}
              placeholder={""}
              block
            />
          </div>
          <div className="los-lt-range-to">to</div>
          <div className={hasError ? "input-error" : ""}>
            <InputNumber
              value={maxBookingLeadTime}
              min={1}
              max={999}
              onChange={(value) => onRangeChange(value, "max")}
              placeholder={""}
              block
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="tc-section condition-form-section">
      <div className="condition-row">
        <span className="condition-label">Lead Time</span>
        <div className="condition-input-wrapper">
          <SelectPicker
            value={ltType}
            onChange={onLtTypeChange}
            placeholder="Choose an option"
            data={ltTypes}
            block
            container={() => ltTypePopUpRef.current}
            cleanable={false}
            searchable={false}
          />
          <div className="position-relative" ref={ltTypePopUpRef} />
          <div
            className={`los-lt-input ${
              ltType === "3" ? "los-lt-input-range" : ""
            }`}
          >
            {renderInput()}
          </div>
        </div>
        <button
          type="button"
          className="remove-condition-btn"
          onClick={onRemove}
        >
          <img src={deleteIcon} alt="Delete" className="delete-icon" />
        </button>
      </div>
    </div>
  );
}

LeadTimeSection.propTypes = {
  ltType: PropTypes.string,
  minBookingLeadTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxBookingLeadTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLtTypeChange: PropTypes.func.isRequired,
  onMinMaxChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

export default LeadTimeSection;
